import { SearchNormal1 } from "iconsax-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Dropdown, DropdownMenu, DropdownToggle, Input, Row } from "reactstrap";
import { Href, NextJob, Search } from "../../../constants";
import { Cities, NextJobContent } from "../../../data/demo/JobDemo2";
import { JobCategoriesScrollData, JobHomeIcon, SelectExperienceData } from "../../../data/demo/JobDemo3";
import { routes } from "../../../routers/routes";
import { dynamicImage, dynamicNumber, dynamicSvg, Image } from "../../../utils";
import RatioImage from "../../../utils/RatioImage";
import CitySelectMenu from "../../commonComponents/CitySelectMenu";

const JobHomeSection = () => {
  const [selectedCity, setSelectedCity] = useState(["Select Experience", "Select Location"]);
  const [dropdownOpen, setDropdownOpen] = useState([false, false]);

  const toggleDropdown = (index: number) => setDropdownOpen((prev) => prev.map((isOpen, i) => (i === index ? !isOpen : isOpen)));
  const handleSelect = (index: number, value: string) => setSelectedCity((prev) => prev.map((item, i) => (i === index ? value : item)));

  useEffect(() => {
    const handleScroll = () => {
      const translateAngle = window.pageYOffset * 0.15;

      const translateObjectsRight = document.querySelectorAll(".scroll-quote .marquee");
      const translateObjectsLeft = document.querySelectorAll(".reverse-quote .marquee");

      translateObjectsRight.forEach((object) => ((object as HTMLElement).style.transform = `translateX(${translateAngle}px)`));
      translateObjectsLeft.forEach((object) => ((object as HTMLElement).style.transform = `translateX(-${translateAngle}px)`));
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="job3-home-section">
      <ul className="home-icons">
        {JobHomeIcon.map((item, index) => (
          <li key={index}>
            <div className="job-bg-icon">
              <Image src={dynamicSvg(`job/job-box/${item}.svg`)} alt={`ji-${item}`} className="img-fluid" />
            </div>
          </li>
        ))}
      </ul>
      <RatioImage src={dynamicImage("job-3/bg-effect/home-bg-effect.png")} className="bg-img" alt="job" />
      <Container>
        <Row className="justify-content-center">
          <Col xxl="8" xl="9" lg="10">
            <div className="home-content">
              <h1 className="text-white">{NextJob}</h1>
              <p>{NextJobContent}</p>
              <div className="search-input-home">
                <div className="icon-search">
                  <SearchNormal1 className="iconsax" />
                  <Input type="text" placeholder="Enter skills / Companies" />
                </div>
                {dynamicNumber(2).map((item, index) => (
                  <Dropdown isOpen={dropdownOpen[index]} toggle={() => toggleDropdown(index)} className={`select-dropdown d-md-inline-block d-none ${item === 2 ? "full-dropdown" : ""}`} key={index}>
                    <DropdownToggle caret className="select-button" color="transparent">
                      {selectedCity[index]}
                    </DropdownToggle>
                    <DropdownMenu>
                      {item === 1 ? (
                        <ul className="select-menu">
                          {SelectExperienceData.map((list, idx) => (
                            <li key={idx}>
                              <Link className={`select-item ${list === selectedCity[index] ? "active" : ""}`} to={Href} onClick={() => handleSelect(index, list)}>
                                {list}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <Row className="gy-xl-0 gy-3">
                          {Cities.map((cityList, i) => (
                            <CitySelectMenu key={i} multiColumn cityList={cityList} selectedCity={selectedCity[index]} onSelectCity={(city) => handleSelect(index, city)} href={Href} />
                          ))}
                        </Row>
                      )}
                    </DropdownMenu>
                  </Dropdown>
                ))}
                <Link to={routes.Job.Grid.JobLeftSidebar} className="btn-solid">
                  {Search}
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {JobCategoriesScrollData.map((item, index) => (
        <div className={item.class} key={index}>
          <ul className="marquee">
            {item.scrollData.map((data, index) => (
              <li className="marquee-pill" key={index}>
                <Image src={dynamicSvg(`job/category/${data.image}.svg`)} alt={data.title} className="img-fluid" />
                <h6>{data.title}</h6>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default JobHomeSection;
